import ArrowIcon from 'icon/arrow'
import React, { useState } from 'react'

function Accordion({ items = [] }) {
  const [activeTab, setActiveTab] = useState(undefined)

  const handleItemClick = (idx) => {
    setActiveTab(activeTab === idx ? undefined : idx)
  }

  return (
    <div>
      {items.map((item, idx) => {
        const isActive = activeTab === idx

        return (
          <div key={idx}>
            <h2>
              <button
                type='button'
                className={`flex items-center justify-between w-full py-5 font-medium rtl:text-right border-b border-gray-200 ${
                  isActive ? 'text-gray-900 ' : 'text-inherit'
                } gap-3`}
                onClick={() => handleItemClick(idx)}
              >
                <span>{item.title}</span>
                <ArrowIcon className={isActive ? '' : 'rotate-180'} />
              </button>
            </h2>

            <div
              className={`${
                isActive ? '' : 'hidden'
              } py-5 border-b border-gray-200`}
            >
              {item.body}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Accordion
